import axios from "axios";

const instance = axios.create({
  baseURL: process.env.VUE_APP_API,
  headers: { "Content-Type": "application/json" }
});

instance.interceptors.response.use(
  function(response) {
    return response;
  },
  function(error) {
    if (error.response.status == 401) {
      sessionStorage.removeItem("loggedIn");
      sessionStorage.removeItem("loggedInUser");
      sessionStorage.removeItem("pathname");
      location.href = "/";
    }
    return Promise.reject(error);
  }
);

export default instance;
